/**
 * Renders the toc of the document viewer
 */
import React from "react";
import * as TocUtils from "./toc_utils";
import $ from "jquery";

export default class extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedSectionId: props.initialSelectedSectionId
    };
  }

  /**
   * Is fired when component receives a new set of properties
   */
  componentWillReceiveProps(nextProps) {
    if(this.props.initialSelectedSectionId != nextProps.initialSelectedSectionId) {
      this.setState({
        selectedSectionId: nextProps.initialSelectedSectionId
      });
    }
  }

  /**
   * Is fired when a section is clicked
   */
  handleSectionClick(sectionId, metadata, event) {
    event.preventDefault();
    event.stopPropagation();

    this.setState({ selectedSectionId: sectionId });

    if(open && this.props.onSectionOpen) {
      this.props.onSectionOpen(
        TocUtils.getSection(this.props.toc, sectionId),
        metadata
      );
    }
  }

  /**
   * Renders nested sections
   */
  renderSections(selectedSectionIds, parentId = null, level = 0) {
    var sections = [];

    // our default section list, is the toc (the 0 level)
    var toc = TocUtils.getSectionsForParentId(this.props.toc, parentId);

    // walk over given set of sections
    for(let section of toc) {
      let subSections,
          childSections,
          iconClassName;

      childSections = TocUtils.getSectionsForParentId(this.props.toc, section.id);

      // does this section have sub-sections?
      // recursively call this function
      if(childSections.length > 0) {
        let subSectionsClassName = "document-viewer-toc-sections";

        if(selectedSectionIds.indexOf(section.id) != -1) {
          subSectionsClassName += " document-viewer-toc-sections--active";
        }

        subSections = (
          <ul className={subSectionsClassName} key={`section-parent-${section.id}`}>
            {this.renderSections(selectedSectionIds, section.id, level + 1)}
          </ul>
        );
      }

      // ok, on to the section itself
      let sectionClassName = "document-viewer-toc-section-title",
          sectionSpacingStyle = {
            marginLeft: `${level * 15}px`,
            display: "inline-block"
          };

      // determine if we want to highlight the section itself
      if(this.state.selectedSectionId == section.id) {
        sectionClassName += " document-viewer-toc-section-title--active";
      }

      if(selectedSectionIds.indexOf(section.id) != -1 && this.state.selectedSectionId != section.id) {
        sectionClassName += ` document-viewer-toc-section-title--active-level-${level}`;
      }

      if(section.favorite) {
        iconClassName = "icon-favorite";
      }

      if(section.divider) {
        sections.push(
          <li className="document-viewer-toc-section" key={`section-${section.id}`}>
            <div className="document-viewer-toc-section-title document-viewer-toc-section-title--divider">
              <span style={sectionSpacingStyle}>
                <span className={iconClassName}>{section.name}</span>
              </span>
            </div>
          </li>
        );

      } else {
        let mobileExpander;

        // on mobile we render a chevron (arrow to right) that will expand
        // sections
        if(childSections.length > 0) {
          mobileExpander = (
            <div
              className="document-viewer-toc-section-title-expander"
              onClick={this.handleSectionClick.bind(this, section.id, 'expand')} />
          );
        }

        // push to our render stack
        // note that we render for small screens (d-none d-md-block) and
        // different HTML for bigger screens
        sections.push(
          <li className="document-viewer-toc-section" key={`section-${section.id}`}>
            <div className={`d-none d-md-block ${sectionClassName}`}
                 onClick={this.handleSectionClick.bind(this, section.id, 'expand')}
                 rel={section.id}>
              <span style={sectionSpacingStyle}>
                <span className={iconClassName}>{section.name}</span>
              </span>
            </div>

            <div className={`d-block d-sm-none ${sectionClassName}`}
                 onClick={this.handleSectionClick.bind(this, section.id, 'close')}
                 rel={section.id}>
              <span style={sectionSpacingStyle}>
                <span className={iconClassName}>{section.name}</span>
              </span>
              {mobileExpander}
            </div>

            {subSections}
          </li>
        );
      }
    }

    // aaaand... done
    return sections;
  }

  render() {
    var selectedSectionIds = TocUtils.getParentSectionIds(this.props.toc, this.state.selectedSectionId);

    return (
      <div className={`document-viewer-toc-sections document-viewer-toc-sections--root ${this.props.className ? this.props.className : ""}`}>
        {this.props.children}
        <ul>
          {this.renderSections(selectedSectionIds)}
        </ul>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/portal/documents/toc.jsx